import styled from 'styled-components';
import { COLORS } from '@/theme';
import { Button } from '@/ui';

export const StyledActionsWrap = styled.div`
  display: flex;
  gap: 0.75rem;
`;

export const StyledButton = styled(Button)`
  &&& {
    background: ${COLORS.NORMAL_GRAY};
    color: ${COLORS.WHITE};
    height: 2.125rem;
  }
`;
